import { getSessionBoundary, sessionOwnerKey } from "@/lib/api/session";
const RECOVERY_RETURN_TO = "oransimRouteRecoveryReturnTo";
const RECOVERY_DOCUMENT = "oransimRouteRecoveryDocument";
const RECOVERY_OWNER = "oransimRouteRecoveryOwner";

function createDocumentDiscriminator(): string {
  const browserCrypto = globalThis.crypto;
  if (typeof browserCrypto?.randomUUID === "function") {
    return browserCrypto.randomUUID();
  }
  if (typeof browserCrypto?.getRandomValues === "function") {
    const values = browserCrypto.getRandomValues(new Uint32Array(4));
    return Array.from(values, (value) => value.toString(36)).join("-");
  }
  // This value only distinguishes page lifetimes; it has no authentication role.
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

const currentDocument = createDocumentDiscriminator();

export function routeRecoveryNavigationState(returnTo: string): Record<string, string> {
  return {
    [RECOVERY_RETURN_TO]: returnTo,
    [RECOVERY_DOCUMENT]: currentDocument,
    [RECOVERY_OWNER]: `${sessionOwnerKey()}:${getSessionBoundary().generation}`,
  };
}

export function isRouteRecoveryReturn(state: unknown, currentRoute: string): boolean {
  return typeof state === "object"
    && state !== null
    && RECOVERY_RETURN_TO in state
    && (state as Record<string, unknown>)[RECOVERY_RETURN_TO] === currentRoute
    && (state as Record<string, unknown>)[RECOVERY_DOCUMENT] === currentDocument
    && (state as Record<string, unknown>)[RECOVERY_OWNER] === `${sessionOwnerKey()}:${getSessionBoundary().generation}`;
}
